import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteBattery } from '../Api'

export default generateApiAction({
  baseType: Types.BATTERIES.DELETE,
  api: deleteBattery,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/batteries/DeleteAction.js